import * as React from 'react';

interface OptionalProps {
    visible?: boolean;
    default?: React.ReactNode;
    render?: () => React.ReactNode;
}

const Optional: React.FC<OptionalProps> = props =>
    props.visible ? (
        <React.Fragment children={props.render ? props.render() : props.children} />
    ) : (
        <React.Fragment children={props.default} /> || null
    );

export default Optional;
